// extracted by mini-css-extract-plugin
export default {"root":"PieChart_root__U4Vak","pieWrapper":"PieChart_pieWrapper__3Xo2Z"};